
import CrmTaskReminder from "@/modules/CRM/components/CrmTaskReminder";

export default {
  name: "CrmPageHeader",
  components: { CrmTaskReminder },
  props: {
    backLabel: {
      type: String,
      default: "Voltar",
    },
    backTo: {
      type: [Object, String],
      default: null,
    },
    subtitle: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
  },
};
